module.exports = __webpack_public_path__ + "img/tipBg.f92a36ce.png";